<template>
  <div class="documentation-page">
    <div class="documentation-page__container">
      <div class="documentation-header">
        <span class="documentation-title">DOCUMENTS</span>
      </div>
      <div class="documentation-content">
        <nb-table
          id="documentsListTable"
          :data="fillTableDocuments"
          :border="true"
          :stripe="true"
          :responsive="true"
        >
          <nb-table-column
            prop="title"
            width="300"
            label="Title"
            sortable
          ></nb-table-column>
          <nb-table-column
            prop="fileName"
            width="300"
            label="File Name"
            sortable
          ></nb-table-column>
          <nb-table-column label="Document" width="300" align="center">
            <template slot-scope="scope">
              <nb-button
                @click="handleClick(fillTableDocuments, scope.row)"
                type="text"
                name="downloadDocumentButton"
                :loading="scope.row.loadingStatus"
                >DOWNLOAD Document</nb-button
              >
            </template>
          </nb-table-column>
        </nb-table>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Component from "vue-class-component";
import router from "@/router/router";
import { mapState, mapGetters } from "vuex";
import { fetchList, downloadDocument } from "../API/APIFunctions.js";

import { Icon as NbIcon } from "@navblue/navblue-ui";

@Component({
  components: { NbIcon },
  computed: {
    ...mapGetters({}),
  },
  methods: {
    handleClick(data, row) {
      var rowId = data.indexOf(row);
      data[rowId].loadingStatus = true;
      downloadDocument(data[rowId]);
    },
  },
})
export default class Documentation extends Vue {
  data() {
    return {
      fillTableDocuments: [],
    };
  }

  created() {
    let localThis = this;

    //Get uploaded documents
    this.fetchDocumentsList(
      process.env.VUE_APP_UPLOADED_DOCUMENTS_LIST,
      this.fillTableDocuments
    );
  }

  /**
   *Fill documentsList with the documents of the list jogetList of joget backend.
   *All the documents uploaded into Joget shall be visible in this list for all the customer.
   */
  fetchDocumentsList(jogetList, databasesList) {
    let localThis = this;
    fetchList(process.env.VUE_APP_DATABASES_APP_ID, "" + jogetList)
      .then((json) => {
        var data = json.data;
        data.forEach((element) => {
          //Set loading property in element object
          element.loadingStatus = false;
          //Add element to the list
          databasesList.push(element);
        });
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  }
}
</script>
<style lang="scss">
.documentation-page {
  //display: flex;
  justify-content: center;
  //min-height: calc(100vh - var(--size-bar));
  //max-height: calc(100vh - var(--size-bar) + 12px);
  background-image: linear-gradient(#fe30540f, #1624570f);
  .documentation-page__container {
    min-width: calc(var(--unit) * 65);
    box-shadow: 0 8px 20px 0 rgba(25, 25, 25, 0.2);
    overflow: scroll;
    .documentation-header {
      background-color: white;
      height: calc(var(--unit) * 4);
      display: flex;
      align-items: center;
      .documentation-title {
        font-size: calc(var(--unit) * 1.5);
        font-weight: 700;
        color: #333;
        margin-left: calc(var(--unit) * 2);
        .nb-icon {
          margin-right: var(--unit);
        }
      }
    }
  }
}
.documentation-content {
  background-color: #ebebeb;
  padding: calc(var(--unit) * 2);
  .documentation_title {
    margin-bottom: calc(var(--unit) * 2);
    font-size: var(--unit);
    color: var(--color-black4);
    display: flex;
    align-items: center;
    .nb-icon {
      margin-right: calc(var(--unit) * 0.75);
    }
  }
}
</style>
